export const LoginTranslations = {
  en: {
    login: {
      title: "Welcome to Ecochillers",
      subtitle: "Log in to access your performances.",
      emailLabel: "Email",
      passwordLabel: "Password",
      requiredField: "This information is required.",
      forgotPassword: "Forgot Password?",
      loginButton: "Log in",
      noAccount: "Don’t have an account?",
      signUp: "Sign Up",
      termsText: "By signing in, you agree to our",
      termsLink: "Terms and Conditions",
    },
  },

  es: {
    login: {
      title: "Bienvenido a Ecochillers",
      subtitle: "Inicia sesión para acceder a tus hojas de performance.",
      emailLabel: "Correo electrónico",
      passwordLabel: "Contraseña",
      requiredField: "Esta información es obligatoria.",
      forgotPassword: "¿Olvidaste tu contraseña?",
      loginButton: "Iniciar sesión",
      noAccount: "¿No tienes una cuenta?",
      signUp: "Regístrate",
      termsText: "Al iniciar sesión, aceptas nuestros",
      termsLink: "Términos y Condiciones",
    },
  },
};
